"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afcStimulusTemplate = void 0;
// For all tasks except: H&F, Memory Game, Same Different Selection
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const toNumber_1 = __importDefault(require("lodash/toNumber"));
const taskSetup_1 = require("../../taskSetup");
const helpers_1 = require("../helpers");
const __1 = require("../../..");
const _1 = require(".");
const taskStore_1 = require("../../../taskStore");
const displayDebugInfo_1 = require("../helpers/displayDebugInfo");
const handleKeyboard_1 = require("../helpers/handleKeyboard");
const replayButtonHtmlId = 'replay-btn-revisited';
// Previously chosen responses for current practice trial
let practiceResponses = [];
let trialsOfCurrentType = 0;
let startTime;
let keyboardFeedbackHandler;
const incorrectPracticeResponses = [];
function getStimulus(layoutConfigMap, trial) {
    const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
    if (itemLayoutConfig) {
        const audioPath = (itemLayoutConfig === null || itemLayoutConfig === void 0 ? void 0 : itemLayoutConfig.playAudioOnLoad) ? (0, helpers_1.camelize)(stim.audioFile) : 'nullAudio';
        return __1.mediaAssets.audio[audioPath];
    }
}
const getPromptTemplate = (prompt, mediaSrc, mediaAlt, stimText, equalSizeStim, stimulusContainerClassList, promptClassList) => {
    let template = '<div class="lev-stimulus-container">';
    template += (0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId);
    if (prompt) {
        let containerClass = 'lev-row-container instruction';
        if (promptClassList) {
            containerClass = promptClassList.join(' ');
        }
        template += `
      <div class="${containerClass}">
        <p>${prompt}</p>
      </div>
    `;
    }
    if (mediaSrc || stimText) {
        let contentTemplate = '';
        if (mediaSrc) {
            contentTemplate += `
        <img 
          src=${mediaSrc}
          alt=${mediaAlt}
        />
      `;
        }
        if (stimText) {
            contentTemplate += `
        <p>${stimText}</p>
      `;
        }
        // TODO: Remove after LayoutConfig implementation
        let containerClass = equalSizeStim ? 'lev-stim-content' : 'lev-stim-content-x-3';
        if (stimulusContainerClassList) {
            containerClass = stimulusContainerClassList.join(' ');
        }
        template += `
      <div class=${containerClass}>
        ${contentTemplate}
      </div>
    `;
    }
    template += '</div>';
    return template;
};
function getPrompt(layoutConfigMap, trial) {
    // showItem itemIsImage
    const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
    const t = (0, taskStore_1.taskStore)().translations;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
    if (itemLayoutConfig) {
        const { prompt: { enabled: promptEnabled }, classOverrides: { stimulusContainerClassList, promptClassList }, equalSizeStim, showStimImage, stimText: stimulusTextConfig, } = itemLayoutConfig;
        const mediaAsset = (stimulusTextConfig === null || stimulusTextConfig === void 0 ? void 0 : stimulusTextConfig.value)
            ? __1.mediaAssets.images[(0, helpers_1.camelize)(stimulusTextConfig.value)] || __1.mediaAssets.images['blank']
            : null;
        const prompt = promptEnabled ? t[(0, helpers_1.camelize)(stim.audioFile)] : null;
        const mediaSrc = showStimImage ? mediaAsset : null;
        const mediaAlt = (stimulusTextConfig === null || stimulusTextConfig === void 0 ? void 0 : stimulusTextConfig.value) || `Image not loading: ${mediaSrc}. Please continue the task.`;
        const stimText = stimulusTextConfig ? stimulusTextConfig.displayValue : null;
        return getPromptTemplate(prompt, mediaSrc, mediaAlt, stimText, equalSizeStim, stimulusContainerClassList, promptClassList);
    }
}
function generateImageChoices(choices, target) {
    const practiceUrl = 'https://imgs.search.brave.com/w5KWc-ehwDScllwJRMDt7-gTJcykNTicRzUahn6-gHg/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9yZW5k/ZXIuZmluZWFydGFt/ZXJpY2EuY29tL2lt/YWdlcy9pbWFnZXMt/cHJvZmlsZS1mbG93/LzQwMC9pbWFnZXMt/bWVkaXVtLWxhcmdl/LTUvZmF0aGVyLWFu/ZC1kYXVnaHRlci1p/bi10aGUtb3V0ZXIt/YmFua3MtY2hyaXMt/d2Vpci5qcGc';
    return choices.map((choice) => {
        const imageUrl = __1.mediaAssets.images[(0, helpers_1.camelize)(choice)] || practiceUrl;
        // if the task is running in a cypress test, the correct answer should be indicated with 'correct' class
        if (window.Cypress) {
            const isCorrect = choice === target;
            return isCorrect
                ? `<img src=${imageUrl} alt=${choice} class='correct'/>`
                : `<img src=${imageUrl} alt=${choice} />`;
        }
        else {
            return `<img src=${imageUrl} alt=${choice} />`;
        }
    });
}
function getButtonChoices(layoutConfigMap, trial) {
    const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stimulus.itemId];
    const { response } = itemLayoutConfig;
    const target = response.target;
    if (itemLayoutConfig) {
        const { isImageButtonResponse, response: { displayValues: buttonChoices }, } = itemLayoutConfig;
        if (isImageButtonResponse) {
            return generateImageChoices(buttonChoices, target);
        }
        return buttonChoices;
    }
}
function getButtonHtml(layoutConfigMap, trial) {
    const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
    const isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stimulus.itemId];
    if (itemLayoutConfig) {
        const classList = [...itemLayoutConfig.classOverrides.buttonClassList];
        const disableOkButton = itemLayoutConfig.disableOkButton;
        // TODO: Remove once we have a way to handle practice btns
        if (isPracticeTrial) {
            classList.push('practice-btn');
        }
        return `
      <button class='${classList.join(' ')}' ${disableOkButton ? 'disabled' : ''}>%choice%</button>
    `;
    }
}
function doOnLoad(layoutConfigMap, trial, isKeyboardEnabled) {
    var _a, _b;
    const audioConfig = {
        restrictRepetition: {
            enabled: true,
            maxRepetitions: 2,
        },
        onEnded: () => {
            (0, helpers_1.enableOkButton)();
        },
    };
    // play trial audio
    helpers_1.PageAudioHandler.playAudio(getStimulus(layoutConfigMap, trial) || '', audioConfig);
    startTime = performance.now();
    const incorrectPracticeResponses = [];
    (0, taskStore_1.taskStore)('incorrectPracticeResponses', incorrectPracticeResponses);
    const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
    const playAudioOnLoad = itemLayoutConfig === null || itemLayoutConfig === void 0 ? void 0 : itemLayoutConfig.playAudioOnLoad;
    let pageStateHandler;
    if (typeof stim.audioFile === 'string') {
        // no need to handle array case since it's not supported yet
        pageStateHandler = new helpers_1.PageStateHandler(stim.audioFile, playAudioOnLoad);
    }
    else {
        throw new Error('Multiple audio files are not supported in this trial type');
    }
    const isPracticeTrial = stim.assessmentStage === 'practice_response';
    const isInstructionTrial = stim.trialType === 'instructions';
    if (itemLayoutConfig.isStaggered) {
        // Handle the staggered buttons
        const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
        const imgButtons = Array.from(buttonContainer.children);
        let audioKeys = [];
        for (let i = 0; i < imgButtons.length; i++) {
            const img = imgButtons[i].children[0].getElementsByTagName('img')[0];
            const audioKey = (0, helpers_1.camelize)((_a = img === null || img === void 0 ? void 0 : img.alt) !== null && _a !== void 0 ? _a : '');
            audioKeys.push(audioKey);
        }
        (0, helpers_1.handleStaggeredButtons)(pageStateHandler, buttonContainer, audioKeys);
    }
    const currentTrialIndex = taskSetup_1.jsPsych.getProgress().current_trial_global;
    let twoTrialsAgoIndex = currentTrialIndex - 2;
    // Setup Sentry Context
    (0, helpers_1.setSentryContext)({
        itemId: stim.itemId,
        taskName: stim.task,
        pageContext: 'afcStimulus',
    });
    if (stim.task === 'math') {
        twoTrialsAgoIndex = currentTrialIndex - 3; // math has a fixation or something
        // flag correct answers with alt text for math if running a Cypress test
        if (window.Cypress && !isInstructionTrial) {
            const choices = document.querySelectorAll('.secondary, .image-medium, .primary');
            choices[itemLayoutConfig.response.targetIndex].setAttribute('aria-label', 'correct');
        }
    }
    const twoTrialsAgoStimulus = taskSetup_1.jsPsych.data.get().filter({ trial_index: twoTrialsAgoIndex }).values();
    if (isPracticeTrial) {
        const answer = stim.answer.toString();
        const choices = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId].response.values;
        if ((0, taskStore_1.taskStore)().task === 'trog') {
            let feedbackHandler;
            feedbackHandler = (0, helpers_1.addKeyboardListeners)(stim, taskSetup_1.isTouchScreen, layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId]);
            if (feedbackHandler !== undefined) {
                keyboardFeedbackHandler = feedbackHandler;
            }
        }
        else {
            (0, helpers_1.addPracticeButtonListeners)(answer, taskSetup_1.isTouchScreen, choices);
        }
    }
    // should log trialsOfCurrentType - race condition
    if (stim.task === 'math') {
        if (twoTrialsAgoStimulus != undefined && stim.trialType === ((_b = twoTrialsAgoStimulus[0]) === null || _b === void 0 ? void 0 : _b.trialType)) {
            trialsOfCurrentType += 1;
        }
        else {
            trialsOfCurrentType = 0;
        }
    }
    else {
        if (!isPracticeTrial && !isInstructionTrial) {
            trialsOfCurrentType += 1;
        }
    }
    if (stim.trialType !== 'instructions') {
        const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
        const responseButtons = buttonContainer.children;
        const totalResponseButtons = responseButtons.length;
        const { buttonLayout } = (0, taskStore_1.taskStore)();
        if (itemLayoutConfig) {
            if (buttonLayout === 'diamond' && totalResponseButtons === 4) {
                // have to do it in the runtime
                buttonContainer.classList.add('lev-response-row-diamond-layout');
            }
            else {
                buttonContainer.classList.add(...itemLayoutConfig.classOverrides.buttonContainerClassList);
            }
        }
        if (isKeyboardEnabled) {
            Array.from(responseButtons).forEach((el, i) => {
                const keyIndex = totalResponseButtons === 2 ? i + 1 : i;
                (0, helpers_1.addKeyIconHelpers)(el, keyIndex);
            });
        }
        // update the trial number
        taskStore_1.taskStore.transact('trialNumSubtask', (oldVal) => oldVal + 1);
    }
    (0, helpers_1.setupReplayAudio)(pageStateHandler);
    // display debug info if enabled
    (0, displayDebugInfo_1.displayDebugInfo)(stim);
    (0, helpers_1.addExperimenterButtons)();
    (0, helpers_1.setupFullscreenButton)();
}
function doOnFinish(data, task, layoutConfigMap, terminateCat, trial, isKeyboardEnabled, validityEvaluator) {
    var _a, _b, _c, _d;
    helpers_1.PageAudioHandler.stopAndDisconnectNode();
    if ((0, taskStore_1.taskStore)().debug) {
        document.body.removeChild(document.querySelector('.theta-estimate-container'));
    }
    // note: nextStimulus is actually the current stimulus
    const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stimulus.itemId];
    const { runCat, corpus, isRoarApp } = (0, taskStore_1.taskStore)();
    let responseValue = null;
    let target = null;
    let responseIndex = null;
    if ((0, helpers_1.shouldUseClowder)()) {
        (0, helpers_1.checkMaxTimeExceeded)(stimulus.audioFile);
    }
    if (stimulus.trialType !== 'instructions') {
        if (itemLayoutConfig) {
            const { response } = itemLayoutConfig;
            if (!response) {
                throw new Error('Choices not defined in the config');
            }
            const keyboardChoices = (0, handleKeyboard_1.getKeyboardChoices)(itemLayoutConfig);
            responseIndex =
                data.keyboard_response && isKeyboardEnabled
                    ? keyboardChoices.findIndex((f) => f.toLowerCase() === data.keyboard_response.toLowerCase())
                    : data.button_response;
            responseValue = response.values[responseIndex];
            target = response.target;
            data.correct = responseValue === target;
        }
        if (runCat) {
            (0, helpers_1.updateTheta)(stimulus, data.correct);
        }
        // TODO: detect touch input
        const responseType = 'mouse';
        // update running score and answer lists
        if (data.correct) {
            if (stimulus.assessmentStage !== 'practice_response') {
                // practice trials don't count toward total
                taskStore_1.taskStore.transact('totalCorrect', (oldVal) => oldVal + 1);
                (0, taskStore_1.taskStore)('numIncorrect', 0); // reset incorrect trial count
            }
            practiceResponses = [];
        }
        else {
            // Only increase incorrect trials if response is incorrect not a practice trial
            if (stimulus.assessmentStage !== 'practice_response') {
                taskStore_1.taskStore.transact('numIncorrect', (oldVal) => oldVal + 1);
            }
            practiceResponses.push(responseValue);
        }
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            // specific to this trial
            item: (0, toNumber_1.default)(stimulus.item) || stimulus.item,
            answer: target,
            distractors: stimulus.distractors,
            corpusTrialType: stimulus.trialType,
            responseType,
            responseLocation: responseIndex,
            itemUid: stimulus.itemUid,
            audioFile: stimulus.audioFile,
            corpus: corpus,
        });
        // corpusId and itemId fields are used by ROAR but not ROAD
        if ((0, taskStore_1.taskStore)().storeItemId) {
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                corpusId: (0, taskStore_1.taskStore)().corpusId,
                itemId: stimulus.itemId,
            });
        }
        // Adding this seperately or otherwise it will overide
        // the response value added from practice trials
        if (stimulus.assessmentStage !== 'practice_response') {
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                response: responseValue,
            });
        }
        // adding manually since trial does not log it properly
        // for keyboard responses
        if (stimulus.assessmentStage === 'practice_response') {
            const endTime = performance.now();
            const calculatedRt = Math.round(endTime - startTime);
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                rt: calculatedRt,
            });
            if ((0, taskStore_1.taskStore)().task === 'trog') {
                document.removeEventListener('keydown', keyboardFeedbackHandler);
            }
        }
    }
    else {
        // instructions
        (0, taskStore_1.taskStore)('numIncorrect', 0); // reset incorrect trial count
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            // false because it's not a real trial
            correct: false,
        });
    }
    taskSetup_1.jsPsych.data.addDataToLastTrial({
        audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
    });
    if (stimulus.assessmentStage === 'test_response') {
        taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
    }
    if (!isRoarApp) {
        if (itemLayoutConfig.inCorrectTrialConfig.onIncorrectTrial === 'skip' && !runCat) {
            (0, helpers_1.setSkipCurrentBlock)(stimulus.trialType);
        }
        else if ((0, taskStore_1.taskStore)().numIncorrect >= (0, taskStore_1.taskStore)().maxIncorrect && !runCat) {
            (0, _1.finishExperiment)();
        }
        if (terminateCat) {
            (0, helpers_1.shouldTerminateCat)();
        }
        if (itemLayoutConfig === null || itemLayoutConfig === void 0 ? void 0 : itemLayoutConfig.blockedTrials) {
            const nextTrials = (0, taskStore_1.taskStore)().sequentialTrials.filter((trial) => {
                return trial.block_index === stimulus.block_index;
            });
            (0, helpers_1.selectNextSequentialTrial)(nextTrials);
        }
    }
    else if ((0, helpers_1.shouldUseClowder)() && !((_a = stimulus.assessmentStage) === null || _a === void 0 ? void 0 : _a.includes('instruction'))) {
        (0, taskStore_1.taskStore)('previousItem', stimulus);
        (0, taskStore_1.taskStore)('previousAnswer', data.correct ? 1 : 0);
        const stimulusCats = stimulus.zetas.map((zeta) => zeta.cats[0]);
        // Only report response time and accuracy for composite trials (excluding new items)
        if ((0, taskStore_1.taskStore)().task === 'trog') {
            // If validityEvaluator does not exist, do not throw error to allow scores to be calculated
            if (validityEvaluator && !((_b = stimulus.assessmentStage) === null || _b === void 0 ? void 0 : _b.includes('practice')) && stimulusCats.includes('composite')) {
                validityEvaluator.addResponseData(data.rt, data.keyboard_response ? data.keyboard_response : data.button_response, data.correct ? 1 : 0);
            }
            const { catsScaled } = helpers_1.CLOWDER_IRT_HYPERPARAMS[task][(0, taskStore_1.taskStore)().scoringVersion];
            const irtEstimates = (0, helpers_1.getIrtEstimates)(taskSetup_1.clowder.theta, taskSetup_1.clowder.seMeasurement, taskSetup_1.scaleTheta, catsScaled);
            (0, taskStore_1.taskStore)('irtEstimates', irtEstimates);
            // Add theta and thetaSe estimates to populate composite.test
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                ...(0, helpers_1.getItemParameters)(stimulus),
                thetaEstimate: (_c = irtEstimates.composite) === null || _c === void 0 ? void 0 : _c.thetaEstimate,
                thetaSE: (_d = irtEstimates.composite) === null || _d === void 0 ? void 0 : _d.thetaSE,
            });
            taskSetup_1.jsPsych.data.write({
                ...(0, helpers_1.getTrialIrtEstimates)(irtEstimates),
            });
        }
    }
}
const afcStimulusTemplate = ({ responseAllowed, promptAboveButtons, task, layoutConfigMap, terminateCat, validityEvaluator, }, trial) => {
    const isKeyboardEnabled = (0, taskStore_1.taskStore)().task === 'trog' && (0, taskStore_1.taskStore)().isRoarApp;
    return {
        type: plugin_html_multi_response_1.default,
        response_allowed_while_playing: responseAllowed,
        data: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let isPracticeTrial = stim.assessmentStage === 'practice_response';
            return {
                // not camelCase because firekit
                save_trial: true,
                assessment_stage: stim.assessmentStage,
                // not for firekit
                isPracticeTrial: isPracticeTrial,
            };
        },
        stimulus: () => getPrompt(layoutConfigMap, trial),
        prompt_above_buttons: promptAboveButtons,
        keyboard_choices: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap[stim.itemId];
            return isKeyboardEnabled ? (0, handleKeyboard_1.getKeyboardChoices)(itemLayoutConfig) : 'NO_KEYS';
        },
        button_choices: () => getButtonChoices(layoutConfigMap, trial),
        button_html: () => getButtonHtml(layoutConfigMap, trial),
        on_load: () => doOnLoad(layoutConfigMap, trial, isKeyboardEnabled),
        on_finish: (data) => doOnFinish(data, task, layoutConfigMap, terminateCat, trial, isKeyboardEnabled, validityEvaluator),
        response_ends_trial: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            return stim.assessmentStage !== 'practice_response';
        },
    };
};
exports.afcStimulusTemplate = afcStimulusTemplate;
